<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/JkJ66c/tc-custom/9781429935814.jpg?1737767946692" alt="This image is the cover for the book Interesting Times"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Interesting Times
      </h1>
      <p class="bookDescription body article font2">
        <b>The renowned journalist charts the chaotic years between 9/11 and Obama’s first presidential campaign in this National Book Award–winning collection.</b><br/><br/>Throughout his career as a journalist, George Packer has always been attuned to the voices and stories of individuals caught up in the big ideas and events of contemporary history. <i>Interesting Times </i>unites brilliant investigative pieces such as “Betrayed,” about Iraqi interpreters, with personal essays and detailed narratives of travels through war zones and failed states.<br/><br/>Spanning the first decade of the 21st century, Packer brings insight and passion to his accounts of the war on terror, Iraq, political writers, and the 2008 election. Across these varied subjects a few key themes recur: the temptations and dangers of idealism; the moral complexities of war and politics; the American capacity for self-blinding and self-renewal.<br/><br/>Whether exploring American foreign policy, tracking a used T-shirt from New York to Uganda, or describing the ambivalent response in Appalachia to Obama, these essays hold a mirror up to our own troubled times and showcase Packer’s unmistakable perspective, which is at once both wide-angled and humane.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        George Packer
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Farrar, Straus and Giroux
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?f57114c8